<div class="modal-header">
  <h4 class="modal-title">{{ 'header.menu.csv' | translate}}</h4>
</div>

<div class="modal-body pt-0">
  <div class="modal-body-inner">

    <div>
      <div class="row">
        <div class="col-lg-4 text-center">
          <img class="img-fluid" src="ng-assets/img/proj-type-1.jpg" alt="">
        </div>
        <div class="col-lg-6">
          <h4>{{ 'header.menu.csv' | translate}}</h4>
          <p [innerHTML]="'excelImport.message' | translate"></p>
        </div>
        <div class="col-md-12">
          <hr>
        </div>
      </div>
    </div>

    <!-- change Projectname  -->
    <div class="mb-3 row">
      <label class="col-md-4 col-form-label"
             for="project_name">{{'cae.import.label.project_name' | translate}}</label>
      <div class="col-md-8">
        <input type="text" [(ngModel)]="projectName" id="project_name" name="project_name" class="form-control">
      </div>
    </div>

    <!-- Select Carrierrail, first Entry Freemounting  -->
    <div class="mb-3 row">
      <label class="col-md-4 col-form-label" for="text-input">{{'configurationCreation.mounting_rail.label.rail' | translate}}</label>
      <div class="col-md-6">
        <div class="input-group align-items-center gap-2">
          <select id="select1" name="select1" class="form-control"
                  [(ngModel)]="selectedArticle" #railArticle>
            <option [ngValue]=null >{{'cae.import.no_carrierrail' | translate}}</option>
            @for (group of articleViewList(); track group) {
              <optgroup label="{{(dinOrder[group.groupName] || group.groupName) | translate}}">
                @for (article of group.railArticles; track article) {
                  <option [ngValue]="article">{{ getRailArticleLabel(article) | truncate : 60 }}</option>
                }
              </optgroup>
            }
          </select>
          <div class="input-group-append">
            <a (click)="showArticleTechnicalInfo(selectedArticle()?.info)" tooltip [tooltipText]="'article.list.details' | translate">
              <app-svg-icon type="information_circle"/>
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- change Raillength  -->
    @if(selectedArticle()) {
      <div class="mb-3 row" [formGroup]="railForm">
        <label class="col-md-4 col-form-label"
               for="raillength">{{'configurationCreation.mounting_rail.label.rail_length' | translate}}</label>
        <div class="col-md-8">
          <div class="input-group">
            <input type="number" id="raillength" name="raillength" class="form-control"
                   formControlName="railLengthFormControl"  [class.is-invalid]="railForm.controls.railLengthFormControl.invalid">
            <div class="input-group-append">
              <span class="input-group-text">{{'global.unit.label.mm' | translate }}</span>
            </div>
            <div class="invalid-feedback">
              {{railForm.controls.railLengthFormControl.errors?.messageKey | translate:{'0':railForm.controls.railLengthFormControl.errors?.param} }}
            </div>
          </div>
        </div>
      </div>
    }

    <!-- change start distance  -->
    <div class="mb-3 row">
      <label class="col-md-4 col-form-label"
             for="startProjection">{{'configurationCreation.mounting_rail.label.start_projection' | translate}}</label>
      <div class="col-md-8">
        <input type="number" [(ngModel)]="startProjection" id="startProjection" name="startProjection" class="form-control" >
      </div>
    </div>

    <!-- change open side  -->
    <div class="mb-3 row">
      <label class="col-md-4 col-form-label" for="openSideLeft">{{'cae.import.open.side.left' | translate}}</label>
      <div class="col-md-8">
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="checkbox" name="openSideLeft" id="openSideLeft" [(ngModel)]="importOptions.openLeftSide" >
          <label class="form-check-label" for="openSideLeft"></label>
        </div>
      </div>
    </div>


    <!-- set BMKs  -->
    <div class="row">
      <label class="col-md-4 col-form-label" for="text-inputs">{{'cae.import.add_bmks' | translate}}</label>
      <div class="col-md-8">
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="checkbox" name="addEndstopBmk" id="endstopBmk" [(ngModel)]="importOptions.addEndstopBmk">
          <label class="form-check-label" for="endstopBmk">{{'cae.import.add_endstop_bmk' | translate}}</label>
        </div>
      </div>
    </div>

  </div>
</div>

<div class="modal-footer justify-content-between">
  <div class="form-check checkbox me-auto">
    <input type="checkbox" class="form-check-input" id="saveSettings" [(ngModel)]="saveSettings">
    <label for="saveSettings" class="form-check-label">{{'selectProjectReportPopup.properties.remember' | translate}}</label>
  </div>
  <button class="btn btn-secondary btn-cancel" type="button" (click)="close()">{{'global.label.cancel' | translate}}</button>
  <button id="step_forward" class="btn btn-primary btn-forward" type="button" [disabled]="railForm.invalid" (click)="startImport()">{{'global.label.next' | translate}}</button>
</div>
